/*
 * jQuery Reveal Plugin 1.0
 * www.ZURB.com
 * Copyright 2010, ZURB
 * Free to use under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 */

(function ($) {
  /*---------------------------
 Defaults for Reveal
----------------------------*/

  /*---------------------------
 Listener for data-reveal-id attributes
----------------------------*/

  $(document).on("click", "a[data-reveal-id]", function (e) {
    e.preventDefault();
    var modalLocation = $(this).attr("data-reveal-id");
    $("#" + modalLocation).reveal($(this).data());
  });

  /*---------------------------
 Extend and Execute
----------------------------*/

  $.fn.reveal = function (options) {
    if (!$.support.transition) $.fn.transition = $.fn.animate;

    $.cssEase["bounce"] = "cubic-bezier(0.2, 0.8, 0.2, 1)";

    var defaults = {
      hack: false,
      animation: "fade", //fade, fadeAndPop, none
      animationspeed: 300, //how fast animtions are
      closeonbackgroundclick: true, //if you click background will modal close?
      dismissmodalclass: "close-reveal-modal", //the class of a button or element that will close an open modal
    };

    //Extend dem' options
    var options = $.extend({}, defaults, options);

    return this.each(function () {
      /*---------------------------
 Global Variables
----------------------------*/
      var modal = $(this),
        topMeasure = parseInt(modal.css("top")),
        topOffset = modal.outerHeight() + topMeasure,
        locked = false,
        modalBG = $(".reveal-modal-bg");

      /*---------------------------
 Create Modal BG
----------------------------*/
      if (modalBG.length == 0 || options.stack) {
        modalBG = $('<div class="reveal-modal-bg" />').insertAfter(modal);
        modalBG.css("z-index", 100 + $(".reveal-modal-bg").length * 2);
      }
      modal.css("z-index", 100 + $(".reveal-modal-bg").length * 2 + 1);

      /*---------------------------
 Open & Close Animations
----------------------------*/
      //Entrance Animations

      function positionModal(modal) {
        modal.css("margin-top", -(modal.outerHeight() / 2) + "px");
        modal.css("margin-left", -(modal.outerWidth() / 2) + "px");
        modalbody = modal.find(".body");

        modal.css("margin-top", -(modal.height() / 2) + "px");
        modal.css("margin-left", -(modal.width() / 2) + "px");

        modalbody.css("height", "auto");
        modalHeight = modal.outerHeight();
        windowHeight = $(window).height();

        if (windowHeight - 200 <= modalHeight) {
          modalbody.css("height", windowHeight - 200 + "px").css("overflow-y", "scroll");
          modal.css("margin-top", -modal.height() / 2 + "px");
        } else {
          modalbody.css("overflow-y", modal.data("scroll") ?? "visible");
          modal.css("margin-top", -modal.height() / 2 + "px");
        }
      }

      modal.bind("reveal:position", function () {
        positionModal(modal);
      });

      modal.bind("reveal:open", function () {
        modalBG.unbind("click.modalEvent");
        $("." + options.dismissmodalclass).unbind("click.modalEvent");
        if (!locked) {
          lockModal();
          if (options.animation == "fade") {
            if (modalBG.data("preloaded") != true) {
              modalBG.css({ opacity: 0, display: "block" });
              modalBG.transition({ opacity: 1, duration: 250, easing: "out" });
            }
            positionModal(modal);
            modal
              .css({ opacity: 0, display: "block", scale: 0.95 })
              .transition(
                { opacity: 1, duration: 300, scale: 1, timingFunction: "cubic-bezier(0.2, 0.8, 0.2, 1)" },
                function () {
                  modal.trigger("reveal:opened");
                  UI.closePreloader();
                  unlockModal();
                }
              );
          } else {
            modal.css({ opacity: 1, display: "block" });
            unlockModal();
          }
        }
        modal.unbind("reveal:open");
        $("body").addClass("modal-opened");
      });

      //Closing Animation
      modal.bind("reveal:close", function () {
        if (!locked) {
          lockModal();
          modalBG.addClass("is-closing");
          modalBG.transition({ opacity: 0, duration: 500 }, function () {
            $(this).css({ display: "none", opacity: 0 }).remove();
          });
          modal.transition(
            { opacity: 0, scale: 0.8, duration: 350, timingFunction: "cubic-bezier(0.2, 0.8, 0.2, 1)" },
            function () {
              modal.trigger("reveal:closed");
              $(this).css({ display: "none", opacity: 0 }).remove();
              $("body").removeClass("modal-opened");
              unlockModal();
            }
          );
        }
        modal.unbind("reveal:close");
      });

      /*---------------------------
 Open and add Closing Listeners
----------------------------*/
      //Open Modal Immediately
      modal.trigger("reveal:open");

      //Close Modal Listeners
      modal.find("." + options.dismissmodalclass).bind("click", function (e) {
        e.preventDefault();
        modal.trigger("reveal:close");
      });

      if (options.closeonbackgroundclick) {
        modalBG.css({ cursor: "pointer" });
        modalBG.bind("click.modalEvent", function () {
          modal.trigger("reveal:close");
        });
      }
      $("body").keydown(function (e) {
        // do not close modal if a lightbox is present
        if ($(".mfp-container").length > 0) return;

        if (e.which === 27) {
          modal.trigger("reveal:close");
        } // 27 is the keycode for the Escape key
      });

      /*---------------------------
 Animations Locks
----------------------------*/
      function unlockModal() {
        locked = false;
      }
      function lockModal() {
        locked = true;
      }
    }); //each call
  }; //orbit plugin call
})(jQuery);
